import React from "react";
import queryString from "query-string";
import styles from "./Offers.module.sass";
import api from "../../utils/api";
import currency from "../../utils/currency";
import { simulationType } from "../../containers/Products/Products";

import OfferCard from "../../components/OfferCard/OfferCard";
import OfferFilter from "../../components/OfferFilter/OfferFilter";

import Button from "../../components/ui/Button/Button";
import mediaQuery from "../../utils/mediaQuery";
import OfferData from "../../components/OfferData/OfferData";
import Title from "../../components/Title/Title";
import AppContext from "../../contexts/appContext";

class Offers extends React.Component {
  state = {
    groups: [],
    showOfferCount: 3,
    orderBy: "",
    isDesktop: false,
    value: 0,
    simulatedValue: "0,00",
    selectedOffer: null,
  };

  static contextType = AppContext;

  componentDidMount() {
    if (
      mediaQuery.watchIfDesktop((e) => this.setState({ isDesktop: e.matches }))
    ) {
      this.setState({
        isDesktop: true,
        showOfferCount: 6,
      });
    }

    const search = this.props.location.search;
    const { tipo_bem } = queryString.parse(search);
    if (!this.context.ibc && tipo_bem) {
      this.startSimulationHandler();
    } else {
      this.setState({
        orderBy:
          this.context.simulationType === simulationType.PARCELA
            ? "PROXIMITY"
            : "PARCELA_ASC",
        value: currency.currencyToNumber(this.context.simulationValue),
        groups: this.context.groups,
        simulatedValue: this.context.simulationValue,
      });
    }

    window.history.pushState(null, null, null);
    window.addEventListener("popstate", this.backButtonListener);
  }

  componentWillUnmount() {
    mediaQuery.unsubscribe();
    window.removeEventListener("popstate", this.backButtonListener);
  }

  offerChosenHandler = (offer) => {
    const url = this.context.redirectToPayment
      ? "/pagamento"
      : "/confirmar-oferta";
    this.context.setContext({
      ...this.context,
      selectedOffer: offer.group,
      redirectToPayment: false,
    });

    this.props.history.push({
      pathname: url,
    });
  };

  backButtonListener = () => {
    if (this.context.modalOpen || this.state.selectedOffer) {
      this.context.setContext({
        ...this.context,
        modalOpen: false,
      });

      this.setState({ selectedOffer: null });
      window.history.pushState(null, null, null);
    } else {
      this.props.history.goBack();
    }
  };

  showMoreHandler = () => {
    this.setState({
      showOfferCount:
        this.state.showOfferCount + (this.state.isDesktop ? 6 : 3),
    });
  };

  sortHandler = (type) => {
    this.setState({
      orderBy: type,
    });
  };

  sortCards = (cards) => {
    const sort = (offers, type) => {
      switch (type) {
        case "PARCELA_ASC":
          return offers.sort(
            (a, b) => a.dados.valorParcela - b.dados.valorParcela
          );
        case "PARCELA_DESC":
          return offers.sort(
            (a, b) => b.dados.valorParcela - a.dados.valorParcela
          );
        case "CREDITO_ASC":
          return offers.sort(
            (a, b) => a.dados.valorCredito - b.dados.valorCredito
          );
        case "CREDITO_DESC":
          return offers.sort(
            (a, b) => b.dados.valorCredito - a.dados.valorCredito
          );
        default:
          return offers.sort((a, b) => {
            if (this.context.simulationType === simulationType.PARCELA) {
              return (
                this.calcDistance(
                  currency.currencyToNumber(this.context.simulationValue),
                  a.dados.valorParcela
                ) -
                this.calcDistance(
                  currency.currencyToNumber(this.context.simulationValue),
                  b.dados.valorParcela
                )
              );
            }
            return (
              this.calcDistance(
                currency.currencyToNumber(this.context.simulationValue),
                a.dados.valorCredito
              ) -
              this.calcDistance(
                currency.currencyToNumber(this.context.simulationValue),
                b.dados.valorCredito
              )
            );
          });
      }
    };
    return [
      ...sort(
        cards.filter((card) => card.desconto),
        this.state.orderBy
      ),
      ...sort(
        cards.filter((card) => !card.desconto),
        this.state.orderBy
      ),
    ];
  };

  calcDistance = (p1, p2) => {
    return Math.abs(p1 - p2);
  };

  reSimulateHandler = () => {
    this.fetchCards(currency.currencyToNumber(this.state.value));
  };

  getLimits(selectedProduct, selectedSimulation) {
    let minVal,
      maxVal = 0;
    if (
      selectedProduct.id === "2" &&
      selectedSimulation === simulationType.CREDITO
    ) {
      minVal = 25000;
      maxVal = 150000;
    } else if (
      selectedProduct.id === "2" &&
      selectedSimulation === simulationType.PARCELA
    ) {
      minVal = 400;
      maxVal = 5000;
    } else if (
      selectedProduct.id === "1" &&
      selectedSimulation === simulationType.CREDITO
    ) {
      minVal = 70000;
      maxVal = 700000;
    } else if (
      selectedProduct.id === "1" &&
      selectedSimulation === simulationType.PARCELA
    ) {
      minVal = 600;
      maxVal = 10000;
    }

    return {
      minVal: minVal,
      maxVal: maxVal,
    };
  }

  averageValue() {
    const search = this.props.location.search;
    if (search) {
      const values = queryString.parse(search);
      return (
        (parseFloat(values.valor_minimo) + parseFloat(values.valor_maximo)) / 2
      );
    }
    return 0;
  }

  getProducts() {
    const requestBody = {
      codigoComissionado: api.CODIGO_COMISSIONADO(),
    };

    return api.post(api.endpoints.PRODUCTS, requestBody);
  }

  startSimulationHandler = async () => {
    const search = this.props.location.search;
    const {
      tipo_bem,
      tipo_simulacao,

    } = queryString.parse(search);
    const selectedSimulation =
      tipo_simulacao.toLowerCase() === simulationType.PARCELA
        ? simulationType.PARCELA
        : simulationType.CREDITO;

    const isParcela = selectedSimulation === simulationType.PARCELA;

    const products = await this.getProducts();

    const selectedProduct = products.data.produtos.find(
      (p) => p.id === tipo_bem
    );

    const limits = this.getLimits(selectedProduct, selectedSimulation);

    const averageValue = Math.max(limits.minVal, Math.min(this.averageValue(), limits.maxVal));
    const simulationValue = currency.numberToCurrency(averageValue);

    const requestBody = {
      produto: selectedProduct,
      codigoEmpresa: api.CODIGO_EMPRESA,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      creditoFinal: isParcela
        ? "999999999"
        : (averageValue * 1.1).toFixed(2),
      creditoInicial: isParcela ? "0" : (averageValue * 0.9).toFixed(2),
      parcelaInicial: isParcela ? (averageValue * 0.9).toFixed(2) : "0",
      parcelaFinal: isParcela
        ? (averageValue * 1.1).toFixed(2)
        : "999999999",
      rendaTotal: api.RENDA_TOTAL,
    };

    api
      .post(api.endpoints.OFFERS, requestBody)
      .then((result) => {
        this.context.setContext({
          ...this.context,
          title: null,
          subtitle: null,
          redirectToPayment: false,
          product: selectedProduct,
          simulationType: selectedSimulation,
          simulationValue: simulationValue,
          priceValues: this.getLimits(selectedProduct, selectedSimulation),
          groups: result.data.bem.grupos,
        });
        this.setState({
          orderBy:
            this.context.simulationType === simulationType.PARCELA
              ? "PROXIMITY"
              : "PARCELA_ASC",
          value: simulationValue,
          groups: this.context.groups,
          simulatedValue: simulationValue,
        });
      })
      .catch(() => {
        this.context.setContext({
          ...this.context,
          title: null,
          subtitle: null,
          redirectToPayment: false,
          product: selectedProduct,
          simulationType: selectedSimulation,
          simulationValue: simulationValue,
          priceValues: this.getLimits(selectedProduct, selectedSimulation),
          groups: [],
        });
      });
  };

  fetchCards = (simulationValue) => {
    this.setState({
      groups: [],
    });

    const isParcela = this.context.simulationType === simulationType.PARCELA;

    this.setState({
      simulatedValue: currency.numberToCurrency(simulationValue),
      value: simulationValue,
    });

    this.context.setContext({
      ...this.context,
      simulationValue: currency.numberToCurrency(simulationValue),
    });

    const requestBody = {
      produto: this.context.product,
      codigoEmpresa: api.CODIGO_EMPRESA,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      creditoFinal: isParcela
        ? "999999999"
        : (simulationValue * 1.1).toFixed(2),
      creditoInicial: isParcela ? "0" : (simulationValue * 0.9).toFixed(2),
      parcelaInicial: isParcela ? (simulationValue * 0.9).toFixed(2) : "0",
      parcelaFinal: isParcela
        ? (simulationValue * 1.1).toFixed(2)
        : "999999999",
      rendaTotal: api.RENDA_TOTAL,
    };

    api.post(api.endpoints.OFFERS, requestBody).then((result) => {
      this.setState({
        groups: result.data.bem.grupos,
      });
    });
  };

  static validate(limits, value) {
    const numberValue = isNaN(value) ? currency.currencyToNumber(value) : value;
    return numberValue >= limits.minVal && numberValue <= limits.maxVal;
  }

  simulationValueHandler = (value) => {
    value = currency.currencyToNumber(value);
    if (value !== this.state.value) {
      this.setState({
        value: value,
        valid: Offers.validate(this.context.priceValues, value),
      });
    }
  };

  newSimulationHandler = () => {
    this.props.history.push({
      pathname: "/produtos",
    });
  };

  render() {
    if (!this.context.product) {
      return null;
    }

    const hasOffers = this.state.groups != null;
    const countOffers =
      this.state.groups != null ? this.state.groups.length : 0;
    const sortedCards =
      this.state.groups != null ? this.sortCards([...this.state.groups]) : [];
    let hasMoreOffers = false;
    let offersToShow;
    if (countOffers > this.state.showOfferCount) {
      hasMoreOffers = true;
      offersToShow = sortedCards.slice(0, this.state.showOfferCount);
    } else {
      offersToShow = sortedCards;
    }
    const hiddenElementsCount = hasOffers ? 3 - (offersToShow.length % 3) : 0;
    const noOffersDisplay = (
      <label className={styles.noOffers}> Sem ofertas disponíveis </label>
    );

    return (
      <div className={styles.Offers}>
        <Title title="As cotas apresentadas estão sujeitas a disponibilidade" />

        <OfferData
          value={this.state.simulatedValue}
          isDesktop={this.state.isDesktop}
          productType={this.context.product.id}
          simulationType={this.context.simulationType}
        />

        <OfferFilter
          selectedSort={this.state.orderBy}
          sortChanged={this.sortHandler}
          isDesktop={this.state.isDesktop}
          reSimulate={this.reSimulateHandler}
          valueChanged={this.simulationValueHandler}
          type={this.state.selectedSimulation}
          isValid={Offers.validate(this.context.priceValues, this.state.value)}
          value={currency.numberToCurrency(this.state.value)}
          hasChanged={
            this.state.value !==
            currency.currencyToNumber(this.state.simulatedValue)
          }
          minValue={this.context.priceValues.minVal}
          maxValue={this.context.priceValues.maxVal}
          simulatedValue={currency.currencyToNumber(this.state.simulatedValue)}
          simulationType={this.context.simulationType}
        />
        {hasOffers ? (
          <ul className={styles.OffersGrid}>
            {offersToShow.map((el, index) => {
              return (
                <OfferCard
                  key={index}
                  group={el}
                  isDesktop={this.state.isDesktop}
                  simulationType={this.context.simulationType}
                  productType={this.context.product.id}
                  offerChosen={this.offerChosenHandler}
                  ibc={this.context.ibc}
                />
              );
            })}
            {hiddenElementsCount === 2 ? (
              <React.Fragment>
                <OfferCard hidden />
                <OfferCard hidden />
              </React.Fragment>
            ) : hiddenElementsCount === 1 ? (
              <OfferCard hidden />
            ) : null}
          </ul>
        ) : (
          noOffersDisplay
        )}
        {hasMoreOffers ? (
          <Button
            onClick={this.showMoreHandler}
            className={styles.detailsButton}
          >
            Ver mais ofertas
          </Button>
        ) : null}
        {!this.state.isDesktop ? (
          <Button
            onClick={this.newSimulationHandler}
            className={styles.newSimulation}
          >
            Fazer uma nova simulação
          </Button>
        ) : null}
      </div>
    );
  }
}

export default Offers;
